module.exports = __webpack_public_path__ + "media/application/images/svgs/git-merge-642d13baef134cb3539ece2a785f1116.svg";